import { createContext, useContext } from 'react';

import noop from 'utils/noop';
import { EventName } from '../../../domain';
import { ExtendedEventInfo } from '../types';

export interface EventSelectionState {
  selected: ExtendedEventInfo[];
  types: EventName[];
  setTypes: (newSelection: EventName[]) => void;
}

export const defaultContext: EventSelectionState = {
  selected: [],
  types: [],
  setTypes: noop,
};

export const EventSelectionContext = createContext<EventSelectionState>(defaultContext);

export const useEventSelectionContext = () => useContext(EventSelectionContext);
